export const ANY_BTN = 'Any';
export const ANY_BTN_LABEL = 'Any Buying Experience';
export const ONLINE_BTN = 'Online';
export const ONLINE_BTN_LABEL = 'Online Buying Experience';
export const IN_STORE_BTN = 'In-Store';
export const IN_STORE_BTN_LABEL = 'In-Store Buying Experience';

export const BUYING_EXPERIENCE_CREATIVE_ID = 'edm-entry-facets-buying-experience';
